// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Please enter a valid phone number`
};

const de_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Bitte gib eine gültige Telefonnummer ein`
};

const es_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor ingresa un número de teléfono válido`
};

const fr_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Veuillez entrer un numéro de téléphone valide`
};

const fi_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Anna kelvollinen puhelinnumero`
};

const hi_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `कृपया एक वैध फोन नंबर दर्ज करें`
};

const ja_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `有効な電話番号を入力してください`
};

const nl_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Voer een geldig telefoonnummer in`
};

const pt_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Por favor, insira um número de telefone válido`
};

const ro_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Te rugăm să introduci un număr de telefon valid`
};

const th_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง`
};

const ur_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `براہ کرم درست فون نمبر درج کریں`
};

const zh_hant1_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `請輸入有效的電話號碼`
};

const da_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Indtast venligst et gyldigt telefonnummer`
};

const it_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Inserisci un numero di telefono valido`
};

const vn_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Vui lòng nhập số điện thoại hợp lệ`
};

const ko_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `유효한 전화번호를 입력해주세요`
};

const tr_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Lütfen geçerli bir telefon numarası girin`
};

const lv_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Lūdzu, ievadiet derīgu tālruņa numuru`
};

const ar_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `يرجى إدخال رقم هاتف صحيح`
};

const bs_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Molimo unesite važeći broj telefona`
};

const sl_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Prosimo, vnesite veljavno telefonsko številko`
};

const id_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Masukkan nomor telepon yang valid`
};

const sv_widget_login_invalid_phone = /** @type {(inputs: {}) => string} */ () => {
	return `Vänligen ange ett giltigt telefonnummer`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_invalid_phone = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_invalid_phone(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_invalid_phone", locale)
	if (locale === "en") return en_widget_login_invalid_phone(inputs)
	if (locale === "de") return de_widget_login_invalid_phone(inputs)
	if (locale === "es") return es_widget_login_invalid_phone(inputs)
	if (locale === "fr") return fr_widget_login_invalid_phone(inputs)
	if (locale === "fi") return fi_widget_login_invalid_phone(inputs)
	if (locale === "hi") return hi_widget_login_invalid_phone(inputs)
	if (locale === "ja") return ja_widget_login_invalid_phone(inputs)
	if (locale === "nl") return nl_widget_login_invalid_phone(inputs)
	if (locale === "pt") return pt_widget_login_invalid_phone(inputs)
	if (locale === "ro") return ro_widget_login_invalid_phone(inputs)
	if (locale === "th") return th_widget_login_invalid_phone(inputs)
	if (locale === "ur") return ur_widget_login_invalid_phone(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_invalid_phone(inputs)
	if (locale === "da") return da_widget_login_invalid_phone(inputs)
	if (locale === "it") return it_widget_login_invalid_phone(inputs)
	if (locale === "vn") return vn_widget_login_invalid_phone(inputs)
	if (locale === "ko") return ko_widget_login_invalid_phone(inputs)
	if (locale === "tr") return tr_widget_login_invalid_phone(inputs)
	if (locale === "lv") return lv_widget_login_invalid_phone(inputs)
	if (locale === "ar") return ar_widget_login_invalid_phone(inputs)
	if (locale === "bs") return bs_widget_login_invalid_phone(inputs)
	if (locale === "sl") return sl_widget_login_invalid_phone(inputs)
	if (locale === "id") return id_widget_login_invalid_phone(inputs)
	if (locale === "sv") return sv_widget_login_invalid_phone(inputs)
	return "widget_login_invalid_phone"
};